var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.438 27.2311L0.831086 1.63733C0.529286 1.33543 0.529286 0.82363 0.831086 0.53483C1.14609 0.21983 1.64489 0.23293 1.94679 0.53483L27.5536 26.1286C27.8555 26.4304 27.8555 26.9161 27.5536 27.2311C27.2518 27.5461 26.753 27.5461 26.438 27.2311ZM21.0436 3.22543C23.7343 3.22543 25.1911 4.74793 25.1911 7.42543V19.4873C25.1911 20.2223 25.0861 20.9179 24.8761 21.4429L6.65859 3.22543H21.0436ZM26.7268 17.7023V9.95863L31.4649 5.98173C31.9243 5.60113 32.4099 5.35173 32.8955 5.35173C33.8143 5.35173 34.418 6.02113 34.418 7.04483V20.6423C34.418 21.6661 33.8143 22.3354 32.8955 22.3354C32.4099 22.3354 31.9243 22.0861 31.4649 21.7054L26.7268 17.7023ZM6.64549 24.4617C3.95489 24.4617 2.41929 22.9261 2.41929 20.2486V7.45173C2.41929 6.71673 2.55049 6.02113 2.79989 5.57483L21.6868 24.4617H6.64549Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/CameraOff.6afa990f2aa4ab7929024edd9e8a9d54.svg";
export { ForwardRef as ReactComponent };